import { createContext, useContext } from 'react';

/**
 * MarketingShellContext — true when a page renders inside the logged-out
 * MarketingLayout. Marketing pages read this to FORCE dark theme (the
 * logged-out surface is dark-only) regardless of the app theme preference.
 */
export const MarketingShellContext = createContext(false);

export const useInMarketingShell = () => useContext(MarketingShellContext);
